import { useState } from "react";
import { useCart } from "@/lib/cart";
import { checkoutStore } from "@/lib/api";
import { X, Minus, Plus, ShoppingBag } from "lucide-react";
import { toast } from "sonner";

export const CartDrawer = () => {
  const { items, setQty, remove, total, open, setOpen, count } = useCart();
  const [loading, setLoading] = useState(false);

  const checkout = async () => {
    setLoading(true);
    try {
      const res = await checkoutStore({ items: items.map((i) => ({ slug: i.slug, quantity: i.qty })), origin_url: window.location.origin });
      window.location.href = res.checkout_url;
    } catch { toast.error("Could not open checkout. Please try again."); setLoading(false); }
  };

  return (
    <>
      {open && <div className="fixed inset-0 bg-brand-charcoal/40 z-[60]" onClick={() => setOpen(false)} data-testid="cart-overlay" />}
      <aside className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-brand-cream z-[70] shadow-2xl transition-transform duration-500 flex flex-col ${open ? "translate-x-0" : "translate-x-full"}`} data-testid="cart-drawer">
        <div className="flex items-center justify-between px-6 h-20 border-b border-brand-linen">
          <span className="font-serif text-2xl">Your Basket</span>
          <button onClick={() => setOpen(false)} data-testid="cart-close" className="text-brand-charcoal"><X size={22} /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-6">
          {items.length === 0 ? (
            <div className="text-center py-20 text-brand-muted">
              <ShoppingBag size={36} className="mx-auto mb-4 opacity-50" />
              <p className="font-body">Your basket is empty.</p>
            </div>
          ) : items.map((i) => (
            <div key={i.slug} className="flex gap-4 py-4 border-b border-brand-linen" data-testid={`cart-item-${i.slug}`}>
              <img src={i.image} alt={i.title} className="w-20 h-20 object-cover" />
              <div className="flex-1">
                <h4 className="font-serif text-lg leading-tight">{i.title}</h4>
                <p className="font-sans text-sm text-brand-muted mt-1">${i.price.toFixed(2)}</p>
                <div className="flex items-center gap-3 mt-2">
                  <button onClick={() => setQty(i.slug, i.qty - 1)} className="border border-brand-linen w-7 h-7 flex items-center justify-center hover:border-brand-gold"><Minus size={13} /></button>
                  <span className="font-sans text-sm w-5 text-center">{i.qty}</span>
                  <button onClick={() => setQty(i.slug, i.qty + 1)} className="border border-brand-linen w-7 h-7 flex items-center justify-center hover:border-brand-gold"><Plus size={13} /></button>
                  <button onClick={() => remove(i.slug)} className="ml-auto text-brand-copper text-xs uppercase tracking-wide">Remove</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-brand-linen px-6 py-6">
            <div className="flex justify-between mb-1"><span className="font-body text-brand-muted">Subtotal</span><span className="font-serif text-2xl">${total.toFixed(2)}</span></div>
            <p className="font-sans text-[0.66rem] uppercase tracking-[0.12em] text-brand-muted mb-5">Shipping calculated at checkout</p>
            <button onClick={checkout} disabled={loading} data-testid="cart-checkout-btn"
              className="w-full bg-brand-olive text-brand-cream py-4 font-sans uppercase tracking-[0.16em] text-xs hover:bg-brand-charcoal transition-colors disabled:opacity-60">
              {loading ? "Opening checkout…" : `Checkout · ${count} item${count > 1 ? "s" : ""}`}
            </button>
          </div>
        )}
      </aside>
    </>
  );
};
